export enum Section {
    HOME_AUTOMATION = 'home-automation',
    INVENTORY = 'inventories',
    PRICE_TAGS = 'price-tags',
    TRACKING = 'tracking',
    WAREHOUSE = 'warehouse',
}
